import * as Yup from "yup";

export const AddPlayedInitialState = {
  players: [],
};

export const AddPlayedValidationSchema = Yup.object({
  players: Yup.array()
    .min(1, "Selecciona al menos una opción.")
    .of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      })
    ).nullable(),
});
